<template>
    <div class="DashboardSectionHeader">
        <h1>{{ title }}</h1>

        <div class="actions">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DashboardSectionHeader',

    props: {
        title: { type: String, default: '' },
    },
};
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.DashboardSectionHeader {
    display: flex;
    justify-content: space-between;
    padding: $grid-gutter-width 0;

    .actions {
        display: flex;
        align-items: center;

        & > * {
            margin-left: $grid-gutter-width;
        }
    }

    h1 {
        text-transform: capitalize;
        font-weight: $font-weight-regular;
    }
}
</style>
